module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    attrs: {
      "id": "conclusion"
    }
  }, [_vm._m(0), " ", (!_vm.showResults) ? _h('div', {
    staticClass: "finish-continue"
  }, [_h('div', {
    staticClass: "finish-continue__frame"
  }, [_h('div', {
    staticClass: "finish-continue__block"
  }, [_h('div', {
    staticClass: "finish-continue__block-wrap"
  }, [_h('h2', ["Continue your progress"]), " ", _h('p', ["You haven't finished answering all of the questions"]), " ", _h('p', [_h('router-link', {
    staticClass: "finish__button",
    attrs: {
      "to": {
        name: 'intro'
      }
    }
  }, ["Return to the quiz"])])])])])]) : _vm._e(), " ", (_vm.showResults) ? _h('div', {
    staticClass: "finish-results"
  }, [_h('div', {
    staticClass: "finish-results__frame"
  }, [_vm._m(1), " ", _h('div', {
    staticClass: "finish-results__block finish-results__block--half finish-results__block--score"
  }, [_h('div', {
    staticClass: "finish-results__block-wrap"
  }, [_h('h2', ["Your Score"]), " ", _h('p', {
    staticClass: "finish-results__score"
  }, [_vm._s(_vm.score) + "%"]), " ", _h('p', ["You answered " + _vm._s(_vm.right) + "/" + _vm._s(_vm.total), _h('br'), " questions correctly"])])]), " ", _vm._m(2)]), " ", _h('div', {
    staticClass: "finish-results__frame finish-results__return"
  }, [_h('div', {
    staticClass: "finish-results__block"
  }, [_h('div', {
    staticClass: "finish-results__block-wrap"
  }, [_h('h2', ["Become an Eco-School!"]), " ", _h('p', ["Discover how you can make a difference today."]), " ", _vm._m(3), " ", _h('p', [_h('router-link', {
    staticClass: "finish-results__return--button",
    attrs: {
      "to": {
        name: 'intro'
      }
    }
  }, ["Return to the quiz"])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "view"
  }, [_h('ul', {
    staticClass: "scene"
  }, [_h('li', {
    staticClass: "layer scene__layer scene__layer--ground",
    attrs: {
      "data-depth": "-0.2"
    }
  }, [_h('div', {
    staticClass: "scene__illus scene__illus--ground"
  })]), " ", " ", _h('li', {
    staticClass: "layer scene__layer scene__layer--foreground",
    attrs: {
      "data-depth": "0.0"
    }
  }), " ", " ", _h('li', {
    staticClass: "layer scene__layer scene__layer--midground",
    attrs: {
      "data-depth": "0.2"
    }
  }), " ", " ", _h('li', {
    staticClass: "layer scene__layer scene__layer--background",
    attrs: {
      "data-depth": "1"
    }
  }, [_h('img', {
    staticClass: "scene__illus scene__illus--background",
    attrs: {
      "src": require("../../assets/svg/start/background.svg"),
      "alt": ""
    }
  })]), " ", " ", _h('li', {
    staticClass: "scene__sky"
  }, [_h('img', {
    staticClass: "scene__cloud scene__cloud--first",
    attrs: {
      "src": require("../../assets/svg/scene__clouds-1.svg"),
      "alt": ""
    }
  }), " ", _h('img', {
    staticClass: "scene__cloud scene__cloud--second",
    attrs: {
      "src": require("../../assets/svg/scene__clouds-1.svg"),
      "alt": ""
    }
  }), " ", _h('img', {
    staticClass: "scene__cloud scene__cloud--third",
    attrs: {
      "src": require("../../assets/svg/scene__clouds-2.svg"),
      "alt": ""
    }
  }), " ", _h('img', {
    staticClass: "scene__cloud scene__cloud--fourth",
    attrs: {
      "src": require("../../assets/svg/scene__clouds-1.svg"),
      "alt": ""
    }
  }), " ", _h('img', {
    staticClass: "scene__sun",
    attrs: {
      "src": require("../../assets/svg/scene__sun.svg"),
      "alt": ""
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "finish-results__message"
  }, [_h('div', {
    staticClass: "finish-results__message-wrap"
  }, [_h('h1', ["Thank you for taking on the Eco-Schools Quiz!"]), " ", _h('p', ["Each question was designed to get you thinking about simple actions that can be taken to help your school become more eco-friendly. No matter what your score, we hope you feel energised and inspired! And remember, you and your school have the power to make changes that will benefit everyone on our planet."])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "finish-results__block finish-results__block--half finish-results__block--share"
  }, [_h('div', {
    staticClass: "finish-results__block-wrap"
  }, [_h('h2', ["Share the quiz"]), " ", _h('ul', {
    staticClass: "social-media"
  }, [_h('li', {
    staticClass: "social-media__item social-media__item--facebook"
  }, [_h('a', {
    attrs: {
      "href": "https://www.facebook.com/share.php",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, ["Facebook"])]), " ", _h('li', {
    staticClass: "social-media__item social-media__item--twitter"
  }, [_h('a', {
    attrs: {
      "href": "https://twitter.com/intent/tweet",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, ["Twitter"])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('p', [_h('a', {
    attrs: {
      "href": "https://members.eco-schools.org.uk/signup",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, ["Register"])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42aec736!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scenes/Conclusion.vue
// module id = 217
// module chunks = 0